export type NativeMethod = 'GET' | 'POST' | 'PATCH' | 'PUT' | 'DELETE';

const NATIVE_METHODS = new Set<string>(['get', 'post', 'patch', 'put', 'delete']);

/**
 * Resolves a request onto a real, native HTTP method.
 *
 * PATCH/PUT/DELETE are passed through verbatim; the transport never emulates
 * verbs by downgrading them to POST or by injecting override headers or
 * spoofing fields. Unrecognized methods are passed through unchanged.
 */
export function normalizeNativeMethod(method: string | undefined): string {
    if (!method) return 'GET';

    const normalized = method.toLowerCase();
    if (!NATIVE_METHODS.has(normalized)) return method;

    return normalized.toUpperCase();
}